module.exports = __webpack_public_path__ + "img/2_6.5c052f68.png";